import React from 'react';
import { IdCardsActionsProps } from '../types/IdCardTypes';
import { ActionsContainer, RoundedButton } from '../styled';

const IdCardsActions: React.FC<IdCardsActionsProps> = ({
  isActionEnabled,
  onViewIdCards,
  onGeneratePdf,
  viewLoading = false,
  generateLoading = false
}) => (
  <ActionsContainer>
    <RoundedButton
      variant='contained'
      onClick={onViewIdCards}
      disabled={!isActionEnabled}
      loading={viewLoading}
    >
      View ID Cards
    </RoundedButton>
    <RoundedButton
      variant='contained'
      onClick={onGeneratePdf}
      disabled={!isActionEnabled}
      loading={generateLoading}
    >
      Generate PDF
    </RoundedButton>
  </ActionsContainer>
);

export default IdCardsActions;
